import { pull } from 'lodash-es';
import { Observable, Observer } from 'rxjs';

/**
 * An Observable<void> which emits once on subscribe, and once to all
 * subscribers every time {@link refresh} is called.
 *
 * Intended for use in refresh logic with Observables.
 */
export class RefreshObservable extends Observable<void> {
  private readonly observers: Observer<void>[] = [];

  constructor() {
    super(subscriber => {
      subscriber.next();
      this.observers.push(subscriber);

      return () => {
        pull(this.observers, subscriber);
      };
    });
  }

  refresh(): void {
    this.observers.forEach(s => s.next());
  }
}
